import rootSlice from './slice';

const resetPasswordReducer = rootSlice.reducer;

export default resetPasswordReducer;
